import './index.css';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import App from 'App';

// Material Dashboard 2 React Context Provider
import {MaterialUIControllerProvider} from 'context';
import {store, persistor} from 'store/store';
import {PersistGate} from 'redux-persist/integration/react';
import {Provider} from 'react-redux';
import { DurationProvider } from 'context/DurationContext';
import { CountryProvider } from 'context/CountryContext';
import { SubscriptionProvider } from 'context/SubscriptionContext';
import { SubscriptionPricingProvider } from 'context/SubscriptionPricingContext';
import { SubscriptionConfigProvider } from 'context/SubscriptionConfigContext';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate loading={<h1>Loading...</h1>} persistor={persistor}>
        <MaterialUIControllerProvider>
          <DurationProvider>
            <CountryProvider>
              <SubscriptionProvider>
                <SubscriptionPricingProvider>
                  <SubscriptionConfigProvider>
                    <App />
                  </SubscriptionConfigProvider>
                </SubscriptionPricingProvider>
              </SubscriptionProvider>
            </CountryProvider>
          </DurationProvider>
        </MaterialUIControllerProvider>
      </PersistGate>
    </Provider>
  </BrowserRouter>,
);
